const AccountType = Object.freeze({
  INDIVIDUAL: "INDIVIDUAL",
  JOINT: "JOINT",
  COMPANY: "COMPANY",
  TRUST: "TRUST",
});

export default AccountType;
